import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';

import * as LoginActions from './actions';

import LoginNavBar from '../navigation/LoginNavBar';
import ProgressBar from './ProgressBar';
import ChangePassword from './ChangePassword';

import classNames from 'classnames';

import Button from '../components/Button';

import '../css/login.css';

const SignupPage = ({
  dispatch,
  signupInvalid,
  handleChange,
  signupConfirms,
  signupConfirming,
  handleSubmit,
  handleConfirmSubmit,
  handleCancelSubmit,
  loginResult,
  granting,
  committing,
  completed
}) => {
  const classes = {
    modal: (v) => v ? 'bg-navy-muted' : 'bg-navy'
  }
  const [ signupConfirmModal, setSignupConfirmModal ] = useState(null);
  const [ progressModal, setProgressModal ] = useState(null);
  const [ modalDisplayed, setModalDisplayed ] = useState(false);
  const [ changeModal, setChangeModal ] = useState(null);
  const [ willChangePassword, setWillChangePassword ] = useState(false);

  const modalSizeX = "768px";
  const modalSizeY = "256px";
  const signupConfirmsSizeX = "128px";

  const [ finetune, setFinetune ] = useState({
    finetuneX: window.innerWidth,
    finetuneY: window.innerHeight,
  });

  const handleResize = () => {
    setFinetune({
      finetuneX: window.innerWidth,
      finetuneY: window.innerHeight
    });
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, [window.innerWidth, window.innerHeight]);

  const navigate = useNavigate();

  const next = () => {
    setProgressModal(null);
    setModalDisplayed(false);
    setWillChangePassword(true);
  }

  const close = () => {
    setChangeModal(null);
    setWillChangePassword(false);
    dispatch(notifyCompleteConfiguration());
    navigate("/login");
  }

  useEffect(() => {
    if (signupConfirming)
      setSignupConfirmModal(
        <div id='overlay' className='overlay' style={{ width: finetune.finetuneX, height: finetune.finetuneY}}>
          <div id='modal' className='modal-signup'>
            <div className='flex flex-column justify-center items-center' style={{ width: modalSizeX, height: modalSizeY }}>
              <div className='times-new-roman mb2 f4 white'>Are you sure you want to sign up?</div>
              <div className='flex justify-center items-centerm mt2'>
                <Button className='ma2 times-new-roman' onClick={handleConfirmSubmit} style={{ width: signupConfirmsSizeX }}>CONFIRM</Button>
                <Button className='ma2 times-new-roman' onClick={handleCancelSubmit} style={{ width: signupConfirmsSizeX }}>CANCEL</Button>
              </div>
            </div>
          </div>
        </div>
      );
    else
      setSignupConfirmModal(null);
  }, [signupConfirming]);

  useEffect(() => {
    if (granting || committing || completed) {
      setProgressModal(
        <div id='overlay' className='overlay' style={{ width: finetune.finetuneX, height: finetune.finetuneY}}>
          <div id='modal' className='modal-signup'>
            <div className='flex flex-column justify-center items-center'>
              <ProgressBar />
              <Button className='mb4' onClick={next} disabled={granting || committing}>Next</Button>
            </div>
          </div>
        </div>
      )
      setModalDisplayed(true);
    }
  }, [granting, committing]);

  useEffect(() => {
    if (!modalDisplayed)
      return;

    setProgressModal(
      <div id='overlay' className='overlay' style={{ width: finetune.finetuneX, height: finetune.finetuneY }}>
        <div id='modal' className='modal'>
          <div className='flex flex-column justify-center items-center'>
            <ProgressBar />
            <Button className='mb4' onClick={next} disabled={granting || committing}>Next</Button>
          </div>
        </div>
      </div>
    )
  }, [window.innerWidth, window.innerHeight]);

  useEffect(() => {
    if (!willChangePassword)
      return;

    setChangeModal(
      <div id='overlay' className='overlay' style={{ width: finetune.finetuneX, height: finetune.finetuneY}}>
        <div id='modal' className='modal-signup'>
          <div className='flex flex-column justify-center items-center'>
            <ChangePassword
              close={close}
            />
          </div>
        </div>
      </div>
    )
  }, [willChangePassword]);

  return (
    <div className='sans-serif bg-navy'>
      {signupConfirmModal}
      {progressModal}
      {changeModal}
      <div className='z-4 bg-custom-navy-20' style={{ width: '100%', height: '10%' }}>
        <LoginNavBar />
      </div>
      <div className='flex items-center justify-center' style={{ width: finetune.finetuneX, height: finetune.finetuneY * 0.9 }}>
        <div className='mt5 flex flex-column flex-wrap items-center' style={{ overflowY: 'auto' }}>
          <div className='bg-custom-navy-20 pa3'>
              <div className='flex justify-center items-center montserrat pa3 fw4 f3 white'>Get Started</div>
              { signupInvalid && <div className='tc mt3 mb3 pt3 pb3 border-red bg-red-100' >
                <span className='text-red-500'>Invalid signup.</span>
                </div>}
            <div className='flex flex-column'>
              <form className='flex flex-column' onSubmit={handleSubmit}>
                <div className='san-serif white mb2'>EMAIL</div>
                <input
                  type="text"
                  name="emailAddress"
                  placeholder="Specify your e-mail address"
                  onChange={handleChange}
                  className='b--gray mb4'
                  style={{ width: '400px', borderStyle: 'solid', borderWidth: '1px', padding: '8px', outline: '#FF0000' }}
                />
                <div className='san-serif white mb2'>PASSWORD</div>
                <input
                  type="password"
                  name="password"
                  placeholder="Specify your password"
                  autoComplete="off"
                  onChange={handleChange}
                  className='b--gray mb4'
                  style={{ width: '400px', borderStyle: 'solid', borderWidth: '1px', padding: '8px', outline: '#FF0000' }}
                />
                <input
                  type="password"
                  name="confirmedPassword"
                  placeholder="Confirm your password"
                  autoComplete="on"
                      onChange={handleChange}
                      className='b--gray mb4'
                      style={{ width: '400px', borderStyle: 'solid', borderWidth: '1px', padding: '8px', outline: '#FF0000' }}
                    />
                    <Button type="submit" className='san-serif mb4' style={{ padding: '8px' }} >SIGN UP</Button>
                 </form>
                </div>
              </div>
            <div className='pa3 san-serif white'>Already have an account? <button className='san-serif white underline' onClick={() => navigate("/login")}>Log in</button></div>
         </div>
      </div>
    </div>
  )
}

const notifyCompleteConfiguration = () => {
  return {
    type: LoginActions.SIGNUP_CONFIGURATION_COMPLETE
  }
}

const mapStateToProps = state => ({
  loginResult: state.login.loginResult,
  granting: state.login.granting,
  committing: state.login.committing,
  completed: state.login.completed
});

export default connect(mapStateToProps)(SignupPage);
